<template>
  <div class="like-button-wrapper">
    <md-button
      class="like-button"
      :class="{ 'md-icon-button': !showCounter }"
      @click="toggleLike"
      :md-ripple="false"
    >
      <div v-if="$route.path.match(/(strategy)/) != null || $route.path.match(/(activity)/) != null">
        <md-icon :class="{ liked: isLiked }">favorite</md-icon>
      </div>
      <div v-else>
        <md-icon v-if="isLiked" class="liked">favorite</md-icon>
        <md-icon v-else>favorite_border</md-icon>
        <span class="counter" v-if="showCounter">{{ count }}</span>
      </div>
    </md-button>
  </div>
</template>

<script>
export default {
  name: "LikeButton",
  props: ["nid", "uid", "showCounter", "defaultCounter", "defaultLiked"],
  data() {
    return {
      counter: this.defaultCounter,
      liked: this.defaultLiked,
    };
  },
  mounted() {
    this.liked = this.defaultLiked;
    this.counter = this.defaultCounter;
  },
  computed: {
    isLiked() {
      return this.liked !== undefined ? this.liked : this.defaultLiked;
    },
    count() {
      return this.counter !== undefined ? this.counter : this.defaultCounter;
    },
  },
  methods: {
    toggleLike() {
      let liked = this.liked !== undefined ? this.liked : this.defaultLiked;
      let self = this;
      fetch("/like/" + this.nid)
        .then((res) => {
          return res.json();
        })
        .then((json) => {
          self.counter = json;
          self.liked = !liked;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.like-button-wrapper {
  .like-button {
    .counter {
      color: $white;
      padding-left: 10px;
    }
    .md-icon {
      font-size: 20px !important;
      display: block;
      .module-strategy &,
      .module-activity & {
        display: inline;
        color: rgba(255, 255, 255, 0.4);
        @media all and (max-width: $breakpoint-medium) {
          font-size: 18px !important;
        }
      }
      &.liked {
        color: #f64536;
        .module-strategy &,
        .module-activity & {
          color: #f64536;
          @media all and (max-width: $breakpoint-medium) {
            font-size: 18px !important;
          }
        }
      }
    }
  }
}
</style>
